import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Glyph = ({additionalClass, children, glyph}) => {
    const spanClass = classNames(
        'glyphicon',
        glyph,
        additionalClass
    );

    return(
        <span
            aria-hidden="true"
            className={spanClass}>
            {children}
        </span>
    );
};

Glyph.propTypes = {
    additionalClass: PropTypes.string,
    children:PropTypes.node,
    glyph: PropTypes.string.isRequired,
};

export default Glyph;


// WEBPACK FOOTER //
// ./src/components/base/Glyph/Glyph.js